<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar :logo="logo" :app-name="appName">
      <template slot="links">
        <sidebar-item
            :link="{
            name: 'Inicio',
            path: $router.resolve({name:'dashboard'}).href,
            icon: 'fas fa-home',
          }"
        />

        <!-- BASES DE DATOS -->
        <sidebar-item
          v-if="is('Superadmin') || can('data_bases.view.all')"
          :link="{
            name: trans.get('data_bases.hi.data_bases'),
            path: $router.resolve({ name: 'dataBasesList' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <!-- CONVENIOS AEAT Y CC.AA. -->
        <sidebar-item
          v-if="is('Superadmin') || can('convenios_ccaa.view.all')"
          :link="{
            name: trans.get('convenios_ccaa.hi.convenios'),
            path: $router.resolve({ name: 'conveniosCCAAList' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <!-- FORO TÉCNICO -->
        <sidebar-item
          v-if="is('Superadmin') || can('forum:categories.view.all')"
          :link="{
            name: trans.get('forum.hi.forum'),
            path: $router.resolve({ name: 'forumList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- INFORMACIÓN COMPLEMENTARIA -->
        <sidebar-item
          v-if="
            is('Superadmin') ||
            can('additional_information:categories.view.all')
          "
          :link="{
            name: trans.get('additional_information.hi.additional_information'),
            path: $router.resolve({ name: 'additionalInformationList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- CIRCULARES -->
        <sidebar-item
          v-if="is('Superadmin') || can('circulars.view.all')"
          :link="{
            name: trans.get('circulars.hi.circulars'),
            path: $router.resolve({ name: 'circularsApiList' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <!-- SERVICIOS DE VALOR AÑADIDO -->
        <sidebar-item
          v-if="is('Superadmin') || can('value_added_services.view.all')"
          :link="{
            name: trans.get('value_added_services.hi.value_added_services'),
            path: $router.resolve({ name: 'valueAddedServicesList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- SERVICIOS ESPECÍFICOS -->
        <sidebar-item
          v-if="is('Superadmin') || can('specific_services.view.all')"
          :link="{
            name: trans.get('specific_services.hi.specific_services'),
            path: $router.resolve({ name: 'specificServicesList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- SERVICIOS Y UTILIDADES -->
        <sidebar-item
          v-if="is('Superadmin') || can('utilities.view.all')"
          :link="{
            name: trans.get('utilities.hi.utilities'),
            path: $router.resolve({ name: 'utilitiesList' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <!-- ACUERDOS -->
        <sidebar-item
          v-if="is('Superadmin') || can('agreements.view.all')"
          :link="{
            name: trans.get('agreements.hi.agreements'),
            path: $router.resolve({ name: 'agreementsList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- EMPRENDE -->
        <sidebar-item
          v-if="is('Superadmin') || can('entrepreneurships.view.all')"
          :link="{
            name: trans.get('entrepreneurships.hi.entrepreneurships'),
            path: $router.resolve({ name: 'entrepreneurshipsList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- SOFTWARE -->
        <sidebar-item
          v-if="is('Superadmin') || can('software_services.view.all')"
          :link="{
            name: trans.get('software_services.hi.software_services'),
            path: $router.resolve({ name: 'softwareServicesList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- COMUNICACIONES INTERNAS -->
        <sidebar-item
          v-if="
            is('Superadmin') ||
            can('internal_communications:categories.view.all')
          "
          :link="{
            name: trans.get(
              'internal_communications.hi.internal_communications'
            ),
            path: $router.resolve({ name: 'internalCommunicationsList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />


        <!-- PROCESS MANAGEMENT -->
        <sidebar-item
            v-if="is('Superadmin') || can('process_management:view.all')"
            :link="{
                  name: trans.get('process_management.hi.process_management'),
                  path: $router.resolve({name:'processManagementList'}).href,
                  icon: 'fa fa-dot-circle'
              }"/>

        <!-- BIBLIOTECA -->
        <sidebar-item
          v-if="is('Superadmin') || can('library:categories.view.all')"
          :link="{
            name: trans.get('library.hi.library'),
            path: $router.resolve({ name: 'libraryList' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <!-- VIDEOS -->
        <sidebar-item
          v-if="is('Superadmin') || can('videos.view.all')"
          :link="{
            name: trans.get('videos.hi.videos'),
            path: $router.resolve({ name: 'videosList' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <!-- OFICINAS -->
        <sidebar-item
          v-if="is('Superadmin') || can('offices.view.all')"
          :link="{
            name: trans.get('offices.hi.offices'),
            path: $router.resolve({ name: 'officesList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <!-- PROFESIONALES -->
        <sidebar-item
          v-if="is('Superadmin') || can('professionals.view.all')"
          :link="{
            name: trans.get('professionals.hi.professionals'),
            path: $router.resolve({ name: 'professionalsList' }).href,
            icon: 'fas fa-dot-circle',
          }"
        />

        <sidebar-item
            v-if="is('Superadmin') || can('professionals.manage.all')"
            :link="{
                  name: trans.get('professionals.hi.users'),
                  path: $router.resolve({name:'usersList'}).href,
                  icon: 'fas fa-dot-circle'
              }"/>

        <!-- SOPORTE INTERNO -->
        <sidebar-item
          v-if="
            is('Superadmin') ||
            can('internal_support:messages.manage.create') ||
            can('internal_support:areas.manage.all')
          "
          :link="{
            name: trans.get('internal_support.hi.internal_support'),
            path: $router.resolve({ name: 'internalSuportMessageSend' }).href,
            icon: 'fa fa-dot-circle',
          }"
        />

        <sidebar-item
            v-if="is('Superadmin') || can('blog.manage.all')"
            :link="{
                  name: trans.get('blog.hi.blog'),
                  path: $router.resolve({name:'blogPostsList'}).href,
                  icon: 'fa fa-dot-circle'
              }"
              />
              
              <sidebar-item v-if="is('Superadmin') || can('roles.manage.all')"
                      :link="{
              name: trans.get('roles.hi.roles'),
              path: $router.resolve({name:'rolesList'}).href,
              icon: 'fas fa-dot-circle'
              }"
        />
              
      </template>
    </side-bar>

    
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <router-link
          v-if="$route.name !== 'dashboard' && $root.back != null"
          class="btn btn-info btn-go-back-footer"
          ref="goBack"
          :to="$root.back"
          :title="trans.get('hi.go_back')"
          ><i class="fas fa-reply"></i>
        </router-link>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}
function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import Lang from "lang.js";
export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  data() {
    return {
      logo: "/img/logo02.png",
      appName: "...",
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  beforeMount() {
    if (
      typeof window.axios.defaults.headers.common["Authorization"] ===
      "undefined"
    ) {
      this.$router.push({ name: "login" });
    } else {
      console.log(window.axios.defaults.headers.common["Authorization"]);
    }
    this.logo = `${process.env.MIX_BASE_PATH}/img/logo02.png`;
    this.appName = process.env.MIX_APP_NAME;
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style src="vue-notifyjs/themes/default.css"></style>
<style lang="scss"></style>
